<div class="container">
  <div id="carousel{{id}}" (swipeleft)="onCarouselSwipe('left', id)" data-bs-touch="false"
    (panleft)="onCarouselSwipe('left', id)" (swiperight)="onCarouselSwipe('right', id)"
    (panright)="onCarouselSwipe('right', id)" class="carousel slide carouselBlock" data-ride="carousel">

    <div class="carousel-inner">
      @for (item of media; track item; let j = $index) {
      <div class="carousel-item carousel-track-items{{id}} image-slide"
        [ngClass]="{ 'carousel-slide-transition': true }" [class.active]="j === 0">

        @if (item?.mimeType.includes('video') && !(isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
        <div class="carousel-video">
          <video controls #videoElement>
            <source [src]="item.url" type="video/mp4">
            <source [src]="item.url" type="video/ogg">
            Your browser does not support the video.
          </video>
        </div>
        }

        @if (item?.mimeType.includes('video') && (isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
        <div class="carousel-video-intro">
          <app-video-player [media]="item" [introOutroMediaData]="introOutroMediaData"></app-video-player>
        </div>
        }

        @if (item.mimeType.includes('Image') || item.mimeType.includes('image')) {
        <div>
          <a (click)="openMediaModal(item.url, item.altText)">
            <img [src]="item.url" alt="File not found." i18n-alt class="d-block w-100">
          </a>
        </div>
        }

      </div>
      }
    </div>

    @if (media.length > 1) {
    @if (activeSlideIndex > 0) {
    <a class="carousel-control-prev" (click)="onCarouselSwipe('right', id)" role="button" data-slide="prev">
      <img src="../../assets/common/arrows/backward-arrow.svg" alt="File not found." i18n-alt>
    </a>
    }

    @if (activeSlideIndex < media.length - 1) { <a class="carousel-control-next" (click)="onCarouselSwipe('left', id)"
      role="button" data-slide="next">
      <img src="../../assets/common/arrows/forward-arrow.svg" alt="File not found." i18n-alt>
      </a>
      }

      }
  </div>

  @if (media.length > 1) {
  <div class="carousel-indicators-container">
    @for (item of media; track i; let i = $index) {
    <span class="carousel-dot indicators{{id}}" [class.active]="i === activeSlideIndex" (click)="onDotClick(i)">
    </span>
    }
  </div>
  }
</div>

<div class="backdrop"></div>

<div class="modal" #imageModal tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title"></div>
        <button type="button" class="close" (click)="closeMediaModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <img [src]="modalImageUrl" class="d-block w-100" alt="File not found." i18n-alt>
      </div>
    </div>
  </div>
</div>